function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMastercard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 63,
    viewBox: "0 0 79 63",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uxsmzoh08a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    style: {
      fill: "none"
    },
    d: "M0 0h64.13v52.603H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2812"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5781",
    style: {
      fill: "#fff"
    },
    d: "M0 0h79v63H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "02_mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 675",
    style: {
      clipPath: "url(#uxsmzoh08a)"
    },
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2781",
    d: "M27.809 97.714v-2.621a1.554 1.554 0 0 0-1.442-1.659 2.005 2.005 0 0 0-1.668.742 1.533 1.533 0 0 0-1.38-.743 1.381 1.381 0 0 0-1.223.62v-.515h-.909v4.176h.913V95.4a.977.977 0 0 1 .833-1.1.946.946 0 0 1 .189-.007c.6 0 .909.393.909 1.1v2.324h.917V95.4a.985.985 0 0 1 .851-1.1.964.964 0 0 1 .171-.007c.62 0 .917.393.917 1.1v2.324zm13.576-4.176H39.9v-1.267h-.917v1.267h-.847v.83h.847v1.9c0 .97.376 1.546 1.45 1.546a2.139 2.139 0 0 0 1.136-.323l-.262-.778a1.676 1.676 0 0 1-.8.236c-.454 0-.6-.28-.6-.7v-1.881h1.485zm7.749-.1a1.232 1.232 0 0 0-1.1.612v-.507h-.9v4.176h.909v-2.347c0-.69.3-1.074.891-1.074a1.471 1.471 0 0 1 .568.1l.28-.856a1.942 1.942 0 0 0-.649-.109zm-11.715.437a3.122 3.122 0 0 0-1.7-.437c-1.057 0-1.738.507-1.738 1.336 0 .681.506 1.1 1.441 1.232l.428.061c.5.07.734.2.734.437 0 .323-.332.507-.952.507a2.226 2.226 0 0 1-1.389-.437l-.428.708a3.015 3.015 0 0 0 1.808.542c1.206 0 1.9-.568 1.9-1.363 0-.734-.55-1.118-1.459-1.249l-.428-.061c-.393-.052-.708-.131-.708-.41 0-.306.3-.489.8-.489a2.693 2.693 0 0 1 1.3.358zm24.338-.437a1.232 1.232 0 0 0-1.1.612v-.507h-.9v4.176h.909v-2.347c0-.69.3-1.074.891-1.074a1.471 1.471 0 0 1 .568.1l.28-.856a1.942 1.942 0 0 0-.649-.109zM50.05 95.626a2.11 2.11 0 0 0 2.022 2.194 2.034 2.034 0 0 0 .206 0 2.189 2.189 0 0 0 1.5-.5l-.437-.734a1.837 1.837 0 0 1-1.092.376 1.339 1.339 0 0 1 0-2.673 1.831 1.831 0 0 1 1.092.376l.437-.734a2.187 2.187 0 0 0-1.5-.5 2.11 2.11 0 0 0-2.226 1.986c-.004.071-.004.14-.002.209zm8.509 0v-2.088h-.909v.507a1.584 1.584 0 0 0-1.319-.612 2.2 2.2 0 0 0 0 4.386 1.585 1.585 0 0 0 1.319-.612v.507h.909zm-3.381 0a1.254 1.254 0 1 1 0 .1v-.1m-10.963-2.193a2.195 2.195 0 0 0 .061 4.386 2.539 2.539 0 0 0 1.712-.585l-.446-.673a1.99 1.99 0 0 1-1.214.439 1.16 1.16 0 0 1-1.249-1.022h3.1c.009-.114.017-.227.017-.35a2 2 0 0 0-1.981-2.195zm-.017.813a1.037 1.037 0 0 1 1.057 1.013h-2.167a1.075 1.075 0 0 1 1.112-1.013zm22.792 1.38v-3.765h-.91v2.184a1.583 1.583 0 0 0-1.319-.612 2.2 2.2 0 0 0 0 4.386 1.584 1.584 0 0 0 1.319-.612v.507h.909zm1.51 1.482a.417.417 0 0 1 .164.033.429.429 0 0 1 .135.089.423.423 0 0 1 .09.132.408.408 0 0 1 0 .322.421.421 0 0 1-.09.132.44.44 0 0 1-.135.09.408.408 0 0 1-.164.033.423.423 0 0 1-.392-.254.414.414 0 0 1 .225-.543.431.431 0 0 1 .167-.034zm0 .739a.309.309 0 0 0 .125-.025.334.334 0 0 0 .1-.069.325.325 0 0 0 0-.458.332.332 0 0 0-.1-.069.318.318 0 0 0-.125-.026.327.327 0 0 0-.128.025.321.321 0 0 0-.1.069.325.325 0 0 0 0 .458.323.323 0 0 0 .231.095zm.024-.518a.173.173 0 0 1 .114.033.112.112 0 0 1 .04.09.107.107 0 0 1-.032.079.154.154 0 0 1-.091.038l.126.145h-.1l-.117-.145h-.038v.145h-.076v-.385zm-.1.072v.1h.095a.1.1 0 0 0 .052-.013.045.045 0 0 0 .019-.039.043.043 0 0 0-.019-.038.1.1 0 0 0-.052-.013zM63.6 95.625a1.254 1.254 0 1 1 0 .1v-.1m-30.68 0v-2.087h-.9v.507a1.584 1.584 0 0 0-1.319-.612 2.2 2.2 0 0 0 0 4.386 1.585 1.585 0 0 0 1.319-.612v.507h.909zm-3.381 0a1.254 1.254 0 1 1 0 .1q.005-.049.008-.099z",
    transform: "translate(-11.931 -51.731)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    transform: "translate(25.185 9.984)",
    style: {
      fill: "#ff5f00"
    },
    d: "M0 0h13.761v24.728H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2782",
    d: "M34.593 30.883A15.7 15.7 0 0 1 40.6 18.519a15.727 15.727 0 1 0 0 24.728 15.7 15.7 0 0 1-6.007-12.364",
    transform: "translate(-8.534 -8.535)",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2783",
    d: "M98.846 30.883A15.726 15.726 0 0 1 73.4 43.247a15.729 15.729 0 0 0 0-24.728 15.726 15.726 0 0 1 25.446 12.364z",
    transform: "translate(-41.336 -8.535)",
    style: {
      fill: "#f79e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2784",
    d: "M127.8 72.677v-.506h.2v-.1h-.52v.1h.2v.506zm1.009 0v-.61h-.16l-.183.42-.183-.42h-.159v.61h.113v-.46l.172.4h.117l.172-.4v.461z",
    transform: "translate(-71.795 -40.584)",
    style: {
      fill: "#f79e1b"
    }
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-mastercard.211614d2838771f852ac20a84bd689ce.svg";